'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OrderEdit;

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrderEdit(selector) {

    var form = document.querySelector(selector);

    var brandSelect = form.querySelector('[name="brand_id"]');
    var storeSelect = form.querySelector('[name="store_id"]');
    var closeButton = form.querySelector('.close');

    var autoFillPromptElement = form.querySelector('.autofill-prompt');

    var isFetching = false;

    function setupDataPrefill() {
        brandSelect.addEventListener("change", handleBrandStoreSelectChange);
        storeSelect.addEventListener("change", handleBrandStoreSelectChange);
    }

    function handleBrandStoreSelectChange() {
        var brand_id = brandSelect.value;
        var store_id = storeSelect.value;

        if (brand_id && store_id) {
            promptAutofill();
        }
    }

    function promptAutofill() {
        autoFillPromptElement.querySelector('.message').innerHTML = 'Do you want to autofill the same currency, payment terms and discount as was used for the last order?';
        autoFillPromptElement.querySelector('.rwi-btn-rounded').innerHTML = 'Autofill';
        autoFillPromptElement.querySelector('.rwi-btn-rounded').onclick = handlePressAutofill;
        closeButton.onclick = hide;
        autoFillPromptElement.classList.add('show');
    }

    function handlePressAutofill() {
        var brand_id = brandSelect.value;
        var store_id = storeSelect.value;
        autoFillPromptElement.querySelector('.rwi-btn-rounded').innerHTML = '<i class="fa fa-circle-o-notch fa-spin"></i>';
        fullFillAutoFill(brand_id, store_id);
    }

    function fullFillAutoFill(brand_id, store_id) {
        console.log('fetching');
        if (isFetching) return;
        isFetching = true;
        var url = location.origin + '/ajax/getLastOrder';
        (0, _request2.default)(url, {
            qs: {
                brand_id: brand_id,
                store_id: store_id
            }
        }, function (err, response, body) {
            console.log(response);
            if (response.statusCode !== 200) {
                showError();
            } else {
                var order = JSON.parse(body);
                fillInData(order);
                hide();
            }
            isFetching = false;
        });
    }

    function fillInData(order) {
        resetData();

        if (order.currency) {
            form.querySelector('[name="currency"]').value = order.currency;
            form.querySelector('[name="currency"]').classList.add('prefilled');
        }
        if (order.payment_terms) {
            form.querySelector('[name="payment_terms"]').value = order.payment_terms;
            form.querySelector('[name="payment_terms"]').classList.add('prefilled');
        }
        if (order.shipping_terms) {
            form.querySelector('[name="shipping_terms"]').value = order.shipping_terms;
            form.querySelector('[name="shipping_terms"]').classList.add('prefilled');
        }

        if (order.discount) {
            form.querySelector('[name="discount"]').value = parseFloat(order.discount) * 100;
            form.querySelector('[name="discount"]').classList.add('prefilled');
        }
        if (order.settlement_discount) {
            form.querySelector('[name="settlement_discount"]').value = parseFloat(order.settlement_discount) * 100;
            form.querySelector('[name="settlement_discount"]').classList.add('prefilled');
        }

        var paymentTermsData = JSON.parse(order.payment_terms_data);
        for (var key in paymentTermsData) {
            form.querySelector('[name="payment_terms_data[' + key + ']"]').value = paymentTermsData[key];
            form.querySelector('[name="payment_terms_data[' + key + ']"]').classList.add('prefilled');
        }
    }

    function resetData() {

        form.querySelector('[name="currency"]').value = '';
        form.querySelector('[name="discount"]').value = '';
        form.querySelector('[name="settlement_discount"]').value = '';
        form.querySelector('[name="shipping_terms"]').value = '';

        form.querySelector('[name="payment_terms"]').value = '';
        form.querySelector('[name="payment_terms_data[days]"]').value = '';
        form.querySelector('[name="payment_terms_data[deposit]"]').value = '';
        form.querySelector('[name="payment_terms_data[preship]"]').value = '';
    }

    function hide() {
        autoFillPromptElement.classList.remove('show');
    }

    function showError() {
        autoFillPromptElement.querySelector('.message').innerHTML = 'No order found to use. Select different combination or close.';
        autoFillPromptElement.querySelector('.rwi-btn-rounded').innerHTML = 'Close';
        autoFillPromptElement.querySelector('.rwi-btn-rounded').onclick = hide;
    }

    function initDeliveryDatePrefill() {
        checkIfBrandAndSeasonSelected();
    }

    function checkIfBrandAndSeasonSelected() {
        var brand_id = form.querySelector('[name="brand_id"]').value;
        var season = form.querySelector('[name="season"]').value;

        if (brand_id && season) {
            console.log('brand and season found');
            loadDeliveryDatesForBrandAndSeason(brand_id, season);
        } else {
            console.log('no brand and season found');
        }
    }

    function loadDeliveryDatesForBrandAndSeason(brand_id, season) {
        var url = location.origin + '/ajax/brandDeliveryDates/' + brand_id + '/' + season;
        (0, _request2.default)(url, function (err, repsonse, body) {
            if (err) {
                console.error(err);
                return;
            }
            var dates = JSON.parse(body);

            if (dates) {
                fillInDates(dates);
            }
        });
    }

    function fillInDates(dates) {
        form.querySelector('[name="delivery_window_start"]').value = dates.delivery_window_start;
        form.querySelector('[name="delivery_window_end"]').value = dates.delivery_window_end;
        form.querySelector('[name="delivery_window_start"]').classList.add('prefilled');
        form.querySelector('[name="delivery_window_end"]').classList.add('prefilled');
    }

    function isNewOrder() {
        return window.location.pathname == '/data/orders/new/edit';
    }

    function init() {
        if (!isNewOrder()) return;

        setupDataPrefill();
        initDeliveryDatePrefill();
    }

    init();
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/data/OrderEdit.js
// module id = 524
// module chunks = 0